import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["connectButton", "text", "icon", 'address']

  connect() {
    this.connected = false;
  }

  async switchState() {
    if (this.connected) {
      await this.disconnectWallet();
      return;
    }
    
    await this.connectWallet();
  }

  getProvider() {
    if ('phantom' in window) {
      const provider = window.phantom?.solana;
  
      if (provider?.isPhantom) {
        return provider;
      }
    }
  
    window.open('https://phantom.app/', '_blank');
  }

  async connectWallet() {
    const provider = this.getProvider();
    try {
      const resp = await provider.connect();
      this.textTarget.textContent = 'Wallet connected';
      this.textTarget.classList.add('wallet-connected')
      this.iconTarget.innerHTML = this.iconConnected;
      this.addressTarget.hidden = false;
      const publicKey = resp?.publicKey.toString();
      this.addressTarget.textContent = this.trimmedAddress(publicKey);
      this.connected = true;
      const detail = { address: publicKey }
      window.dispatchEvent(new CustomEvent('wallet:connected', { detail }));
    } catch (err) {
      console.error(err);
    }
  }

  async disconnectWallet() {
    const provider = this.getProvider();
    try {
      const resp = await provider.disconnect();
      this.textTarget.textContent = "Connect wallet"
      this.textTarget.classList.remove('wallet-connected')
      this.addressTarget.hidden = true;
      this.iconTarget.innerHTML = this.iconConnect;
      this.connected = false;
      window.dispatchEvent(new CustomEvent('wallet:disconnected'));
      return;
    } catch (err) {
      console.error(err);
    }
  }

  trimmedAddress(address) {
    return address?.slice(0, 7) + "..." + address?.slice(-7);
  }

  get iconConnected() {
    return `<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.7796 14.4668C7.52053 16.4677 5.4107 19 2.60331 19C1.27616 19 4.23774e-05 18.4335 1.02005e-09 15.9722C-0.00010594 9.70374 8.25195 0.000131845 15.9086 1.84871e-09C20.2643 -8.78934e-05 22 3.13401 22 6.69315C22 11.2616 19.1415 16.4853 16.3002 16.4853C15.3984 16.4853 14.956 15.9718 14.956 15.1574C14.956 14.945 14.9899 14.7147 15.0581 14.4668C14.0881 16.1843 12.2166 17.7783 10.4641 17.7783C9.18795 17.7783 8.54144 16.9459 8.54142 15.7771C8.54142 15.3521 8.62649 14.9096 8.7796 14.4668ZM14.4627 4.81971C13.7697 4.82099 13.2972 5.43166 13.2987 6.30283C13.3001 7.17401 13.7747 7.80039 14.4678 7.79914C15.1441 7.79789 15.6164 7.16979 15.6149 6.29859C15.6135 5.42742 15.1391 4.81848 14.4627 4.81971ZM18.1391 4.81556C17.446 4.81683 16.9735 5.42751 16.975 6.29868C16.9765 7.16985 17.4509 7.79624 18.1442 7.79499C18.8205 7.79376 19.2928 7.16564 19.2913 6.29444C19.2898 5.42327 18.8154 4.81433 18.1391 4.81556Z" fill="#AB9FF2"/>
  </svg>
  `
  }

  get iconConnect() {
    return `<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.97112 6.44476C3.20325 9.3472 1.41931 12.8583 1.41935 15.4744C1.41937 16.4828 1.6815 16.9474 1.93296 17.1773C2.20026 17.4217 2.60361 17.5385 3.14503 17.5385C4.2431 17.5385 5.23934 17.0515 6.12807 16.3037C7.01903 15.5541 7.76091 14.5755 8.32963 13.6836L9.59039 14.3328C9.46924 14.6785 9.40971 15.0025 9.40971 15.2942C9.40972 15.6968 9.52119 15.9613 9.66717 16.1202C9.80685 16.2722 10.0542 16.4107 10.4986 16.4107C11.1188 16.4107 11.8224 16.1273 12.5047 15.6165C13.1809 15.1103 13.7798 14.4214 14.1849 13.7137L15.4784 14.2865C15.4293 14.4626 15.4104 14.6066 15.4104 14.7223C15.4104 14.9626 15.4744 15.059 15.5118 15.0971C15.55 15.1359 15.662 15.2172 15.9582 15.2172C16.4102 15.2172 16.9232 15.0111 17.4675 14.5596C18.0097 14.1099 18.5415 13.4493 19.0111 12.6363C19.9528 11.006 20.5806 8.87415 20.5806 6.90907C20.5806 5.37889 20.2015 4.01901 19.4233 3.05498C18.6629 2.11288 17.4517 1.4615 15.5919 1.46154C12.2783 1.46159 8.72905 3.55275 5.97112 6.44476ZM4.9584 5.42074C7.85095 2.38756 11.7429 6.53813e-05 15.5919 1.83276e-09C17.8068 -4.40781e-05 19.4448 0.795045 20.5149 2.12077C21.5673 3.42457 22 5.15388 22 6.90907C22 9.16098 21.2908 11.5486 20.231 13.3835C19.6998 14.3031 19.0647 15.1116 18.3579 15.6978C17.6533 16.2822 16.8353 16.6788 15.9582 16.6788C15.4108 16.6788 14.8941 16.5231 14.5145 16.1369C14.4442 16.0655 14.3821 15.9897 14.3274 15.9102C14.0227 16.2354 13.6903 16.5359 13.3393 16.7987C12.5095 17.4199 11.5179 17.8722 10.4986 17.8722C9.74932 17.8722 9.09735 17.6266 8.63618 17.1247C8.41863 16.8879 8.26145 16.6136 8.15665 16.3179C7.81291 16.7104 7.43583 17.0908 7.02614 17.4355C5.97698 18.3182 4.67322 19 3.14503 19C2.44493 19 1.63062 18.8553 0.990631 18.2703C0.334806 17.6707 2.20394e-05 16.7378 1.06578e-09 15.4744C-5.43122e-05 12.3041 2.07579 8.44349 4.9584 5.42074ZM19.0048 5.09547C19.3167 5.49048 19.4651 6.00421 19.4661 6.53972C19.4679 7.58391 18.8511 8.65481 17.6845 8.65691C17.1366 8.65789 16.6633 8.40662 16.3417 7.99681C16.1538 7.75735 16.0253 7.47518 15.9525 7.17203C15.7564 7.97759 15.1757 8.65904 14.2453 8.66074C13.6975 8.66172 13.2242 8.41042 12.9026 8.00068C12.5898 7.60212 12.4416 7.08522 12.4407 6.55007C12.4398 6.01453 12.5865 5.49856 12.9013 5.10123C13.2247 4.69287 13.6974 4.44995 14.2381 4.44897C14.7764 4.448 15.2455 4.69383 15.5657 5.09931C15.7517 5.3349 15.8795 5.61272 15.9526 5.91221C16.0252 5.6125 16.1531 5.33393 16.3404 5.0974C16.6639 4.68903 17.1365 4.44611 17.6773 4.44513C18.2156 4.44417 18.6847 4.68999 19.0048 5.09547Z" fill="black"/>
  </svg>
  `
  }
}
